import React from "react";
import App from "./App";
import ReactDOM from 'react-dom/client';
import { unmountComponentAtNode } from "react-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient()

class WebComponent extends HTMLElement {

    connectedCallback() {
        const root = ReactDOM.createRoot(this);
        const props = {
            objectDefinitionId: this.getAttribute('id'),
            objectDefinitionERC: this.getAttribute('erc'),
        };

        const theme = createTheme();
        root.render(
            <QueryClientProvider client={queryClient}>
                <ThemeProvider theme={theme}>
                    <App {...props} />
                </ThemeProvider>
            </QueryClientProvider>
        );
    }

    disconnectedCallback() {
        unmountComponentAtNode(this);
    }
}

const ELEMENT_NAME = "reactjs-ext-bicici-kyc-client-historik";

if (customElements.get(ELEMENT_NAME)) {
    console.log(
        `Skipping registration for <${ELEMENT_NAME}> (already registered)`
    );
} else {
    customElements.define(ELEMENT_NAME, WebComponent);
}
